import { createReducer } from '@reduxjs/toolkit'

import * as globalFilterActions from 'redux/actions/GlobalFilter/actions'
import { ECurrency } from 'types/Enums'

import * as actions from '../../actions/CurrencyConverter/actions'
import * as authenticationActions from '../../actions/Authentication/actions'

export type CurrencyConverterStore = {
  currency: ECurrency | null
}

const INITIAL_STATE: CurrencyConverterStore = {
  currency: null
}

export default createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(actions.setCurrency, (state, action) => {
      state.currency = action.payload
    })
    .addCase(globalFilterActions.update, (state, action) => {
      if (action.payload.currency !== undefined) {
        state.currency = action.payload.currency
      }
    })
    .addCase(authenticationActions.signOut, () => INITIAL_STATE)
})
